import {
	SAVE_PATIENT_NOTE_SUCCESS,
	SAVE_PATIENT_NOTE_REQUEST,
	SAVE_PATIENT_NOTE_FAILURE
} from "../../constants"


import { pharmacy_save_patient_notes } from "../../../networking/urlEndPoints"
import { fetchPatientsList } from "./patientsList"

import Axios from "../../../networking/intraceptor"

import * as routesNames from '../../../routes/routeName'
import * as pharmacyTeamNotes from '../pharmacy/other'
import { FetchPatientReminderNotificationList } from "../pharmacy/other/pharmacyPatientNotifications"
import { toast } from "react-toastify"

export const savePatientNoteRequest = () => ({
	type: SAVE_PATIENT_NOTE_SUCCESS,
})

export const savePatientNoteSuccess = (data) => ({
	type: SAVE_PATIENT_NOTE_REQUEST,
	payload: data,
})

export const savePatientNoteFailure = (error) => ({
	type: SAVE_PATIENT_NOTE_FAILURE,
	payload: error,
})

export const savePatientNotes = (patient_id, notesData,
	showToast,
	setShowToast,
	paginationNumber,
	location,
	showModal,
	setShowModal,
	queryStatus,
	querySearch,
	color,
	type,
	notify_team_user,
	team_user_ids
) => {

	return async (dispatch) => {
		dispatch(savePatientNoteRequest())
		try {
			const requestData = {
				patient_id: patient_id,
				notes: notesData.notes,
				selectednoteoption: notesData.selectedNoteOptions,
				recurrence: notesData.recurrence,
				remind_days: notesData.remind,
				color: color ? color : '#FFFFFF'
			};

			// Add notify_team_user and team_user_ids if notify_team_user is true
			if (notify_team_user) {
				requestData.notify_team_user = true;
				requestData.team_user_ids = team_user_ids || [];
			}

			const response = await Axios.post(`${pharmacy_save_patient_notes}`, requestData)
			if (response?.status === 200) {
				dispatch(savePatientNoteSuccess(response?.data))
				setShowModal({
					...showModal,
					patientNoteModal: false
				})

				if (typeof setShowToast === 'function') {
					setShowToast({
						...showToast,
						patientNoteToast: true
					})

					setTimeout(() => {
						setShowToast({
							...showToast,
							patientNoteToast: false
						})
					}, 3000);
				}

				if (type === 'patient_profile_note') return

				if (location.pathname === routesNames.ALL_PATIENTS) {
					dispatch(fetchPatientsList(querySearch, queryStatus, paginationNumber))
				}

				if (location.pathname === routesNames.pharmacy_reminder_notes) {
					dispatch(FetchPatientReminderNotificationList())
				}
				else if (location.pathname === routesNames.DASHBOARD_ROUTE || location.pathname === routesNames.HOME_ROUTE) {
					const addTeamNoteData = {
						marknotes: true
					}
					dispatch(pharmacyTeamNotes.fetchPatientNotifications(null, null, addTeamNoteData))
				}
				else {
					dispatch(pharmacyTeamNotes.fetchPatientNotifications(null, null, null))
				}

			} else {
				throw new Error(response)
			}

		} catch (error) {

			if (error?.response) {
				dispatch(savePatientNoteFailure(error?.response))
			}

			if (typeof setShowToast === 'function') {
				setShowToast({
					...showToast,
					patientNoteToastError: true
				})

				setTimeout(() => {
					setShowToast({
						...showToast,
						patientNoteToastError: false
					})
				}, 3000);
			}
		}
	}
}


export const UpdateNotes = (patient_id,
	paginationNumber,
	setAddTeamNoteData,
	addTeamNoteData,
	color,
	type
) => {

	return async (dispatch) => {
		dispatch(savePatientNoteRequest())
		try {
			const reqData = {
				patient_id: patient_id,
				color: color ? color : '#FFFFFF',
			}

			if (type) reqData.ntype = type

			const response = await Axios.post(`${'pharmacy-notes-update-color'}`, reqData)
			if (response?.status === 200) {
				dispatch(savePatientNoteSuccess(response?.data))
				const params = {
					page: paginationNumber
				}
			

				if (type === 'reminder') {
						if (addTeamNoteData.search) params.search = addTeamNoteData.search;
						if (addTeamNoteData.startDate) params.from_date = addTeamNoteData.startDate;
						if (addTeamNoteData.endDate) params.to_date = addTeamNoteData.endDate;
						if (addTeamNoteData.noteoption) params.noteoption = addTeamNoteData.noteoption;
					dispatch(FetchPatientReminderNotificationList(params))
				} else {
					dispatch(pharmacyTeamNotes.fetchPatientNotifications(paginationNumber=1, setAddTeamNoteData, addTeamNoteData, null, "fetchPatientNotifications",))
				}

			} else {
				throw new Error(response)
			}

		} catch (error) {

			if (error?.response) {
				dispatch(savePatientNoteFailure(error?.response))
			}
		}
	}
}

export const handleSavePatientNotes = ({ reqData }) => {

	return async (dispatch) => {
		dispatch(savePatientNoteRequest())
		try {

			const response = await Axios.post(`${pharmacy_save_patient_notes}`, reqData)
			if (response?.status === 200) {
				dispatch(savePatientNoteSuccess(response?.data))
				toast.success('Note added Successfully')
			}
		} catch (error) {
			if (error?.response) {
				const errorMessage = error?.response?.data?.message || 'Failed to add note. Please try again.';
				toast.error(errorMessage); // Display the error message
				dispatch(savePatientNoteFailure(error?.response))
			}
		}
	}
}